/**
 * UA 工具 — 浏览器环境/设备类型判断
 */
window.ttx = window.ttx || {};

(function () {
    var ua = navigator.userAgent || '';

    /** 是否移动端 */
    ttx.ua = ttx.ua || {};
    ttx.ua.isMobile = /Mobi|Android|iPhone|iPad/i.test(ua);

    /** 是否 iOS */
    ttx.ua.isIOS = /iPhone|iPad|iPod/i.test(ua);

    /** 是否 Android */
    ttx.ua.isAndroid = /Android/i.test(ua);

    /** 是否微信内置浏览器 */
    ttx.ua.isWeChat = /MicroMessenger/i.test(ua);

    /** 是否企业微信 */
    ttx.ua.isWxWork = /wxwork/i.test(ua);

    /** 是否钉钉 */
    ttx.ua.isDingTalk = /DingTalk/i.test(ua);
})();
